// SCSS
import './main.scss';
import 'bootstrap/scss/bootstrap.scss';

// Components
import './registration-react/index';


// WEBPACK FOOTER //
// ./main.js